import { useNavigate, NavigateFunction } from "react-router-dom";

interface WrestlerNavigationData {
    wrestler_id: number | string;
    name: string;
}

export function useNavigateToWrestler(
    wrestler: WrestlerNavigationData,
    navigate: NavigateFunction | null = null,
    setIsLoading: ((loading: boolean) => void) | null = null
): void {
    const navigateHook = useNavigate();

    const navigateFn = navigate || navigateHook;

    if (setIsLoading) {
        setIsLoading(true);
    }
    const wrestlerId = wrestler.wrestler_id;
    const wrestlerName = wrestler.name;
    navigateFn(`/wrestlers/i_${wrestlerId}_d_${wrestlerName}`);
    if (setIsLoading) {
        setIsLoading(false);
    }
}
